import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const COLUMN_SCHEMA = [
  {
    key: "icon",
    label: "Icon (truck | shield | lock)",
    type: "string" as const,
  },
  { key: "title", label: "Title", type: "string" as const },
  { key: "subtitle", label: "Subtitle", type: "string" as const },
];

const PROMO_BANNER_SCHEMA = [
  { key: "image", label: "Picture", type: "image" as const, help: "Wide, about 1240 × 310 px (two side by side: 2:1); may carry its own artwork." },
  { key: "title", label: "Caption title (optional)", type: "string" as const },
  { key: "subtitle", label: "Caption line (optional)", type: "string" as const },
  { key: "ctaText", label: "Link text (optional)", type: "string" as const },
  { key: "ctaLink", label: "Link", type: "string" as const },
];

const PICTURE_TILE_SCHEMA = [
  { key: "image", label: "Picture", type: "image" as const, help: "Square, about 800 × 800 px; may carry its own artwork." },
  { key: "alt", label: "Picture description", type: "string" as const, help: "What the picture shows, for screen readers." },
  { key: "title", label: "Title over the picture (optional)", type: "string" as const },
  { key: "ctaLink", label: "Link", type: "string" as const, placeholder: "/shop" },
];

export const schema: ComponentSchema = {
  type: "banner",
  label: "Banner Section",
  description: "Promo feature strip, side-by-side image banners or a row of square picture tiles.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "Selling points strip",
      fields: [
        { key: "columns", label: "Feature Columns", type: "array", itemSchema: COLUMN_SCHEMA },
      ],
    },
    {
      id: "v2",
      label: "Two picture banners",
      fields: [
        { key: "banners", label: "Promo Banners (max 2)", type: "array", itemSchema: PROMO_BANNER_SCHEMA },
      ],
    },
    {
      id: "v3",
      label: "Square picture tiles",
      fields: [
        { key: "title", label: "Section title", type: "string" },
        { key: "banners", label: "Picture tiles (up to 4)", type: "array", itemSchema: PICTURE_TILE_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
